module.exports = __webpack_public_path__ + "img/destinations-no-data.bc57834d.png";